import React, { useState } from 'react'
import { Table, Button, Divider, Popconfirm, Row, Col, Tag, Card } from 'antd'
import { ButtonEx } from '../../styles/button.style'
import BrandNewsForm from './BrandNewsForm'
import { ACTION } from '../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import {
  createBrandNews,
  deleteBrandNews,
  fetchBrandNewsList,
  updateBrandNews
} from '../../modules/brandNews'
import PreviewImage from '../../components/PreviewImage'

const BrandNews = ({ brandId }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [previewImage, setPreviewImage] = useState(null)
  const [formState, setFormState] = useState(null)
  const [action, setAction] = useState(ACTION.CREATE)

  const { brandNewsList } = useSelector(
    (state) => ({
      brandNewsList: state.brandNews.brandNewsList
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchBrandNewsList(brandId))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const columns = [
    {
      title: 'No',
      key: 'No',
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: 'ภาพ',
      dataIndex: 'image',
      key: 'image',
      render: (text, record) => (
        <a
          onClick={() => {
            setVisiblePreview(true)
            setPreviewImage(record.image)
          }}>
          View
        </a>
      )
    },
    {
      title: 'หัวข้อ',
      key: 'title',
      dataIndex: 'title'
    },
    {
      title: 'URL',
      key: 'url',
      dataIndex: 'url'
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (text) =>
        text ? (
          <Tag color="green">Enabled</Tag>
        ) : (
          <Tag color="red">Disabled</Tag>
        )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => onClick(e, ACTION.UPDATE, record)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  async function onOk(data) {
    data.brandId = brandId

    if (action === ACTION.CREATE) {
      await dispatch(createBrandNews(data))
    } else {
      await dispatch(updateBrandNews(data))
    }

    await setVisible(false)
    await dispatch(fetchBrandNewsList(brandId))
  }

  async function onDelete(id) {
    await dispatch(deleteBrandNews(id))
    await dispatch(fetchBrandNewsList(brandId))
  }

  const onClick = (e, type, record) => {
    e.preventDefault()
    setVisible(true)
    setAction(type)

    if (type === ACTION.UPDATE) {
      setFormState(record)
    }
  }

  const onCloseModal = () => {
    setVisible(false)
    setFormState(null)
  }

  return (
    <Card
      title="Brand News"
      extra={<Row type="flex">
        <Col span={12}>
        </Col>
        <Col span={12}>
          <Row type="flex" justify="end">
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e, ACTION.CREATE)}>
              Add News
            </ButtonEx>
          </Row>
        </Col>
      </Row>}>
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
      <Table
        bordered
        dataSource={brandNewsList}
        columns={columns}
      // pagination={{
      //   current: barcodeProductObj.pageable.pageNumber + 1,
      //   pageSize: barcodeProductObj.size,
      //   pageSizeOptions: ['10', '20', '50', '100'],
      //   showSizeChanger: true,
      //   onShowSizeChange: onShowSizeChange,
      //   onChange: onChange,
      //   total: barcodeProductObj.totalElements
      // }}
      />
      <BrandNewsForm
        action={action}
        formState={formState}
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

export default BrandNews



// WEBPACK FOOTER //
// ./src/pages/BrandNews/index.js